<template>
  <ValidationProvider :rules="rules" :vid="vid" v-slot="validationContext">
    <date-picker
      v-model="model"
      value-type="format"
      format="DD-MM-YYYY"
      :editable="false"
      @change="onInput"
      :range="true"
      :disabled-date="disabledDate"
      :disabled="disabled"
      ref="datePicker"
      :clearable="false"
    >
      <template v-slot:input>
        <b-form-group>
          <template v-slot:label>
            <span v-html="formattedLabel" v-if="formattedLabel"></span>
          </template>
          <b-input-group class="mb-3">
            <b-form-input
              :value="formattedDate"
              :type="type"
              readonly
              :placeholder="placeholder"
              :disabled="disabled"
              :state="getValidationState(validationContext)"
            >
            </b-form-input>
            <b-input-group-append>
              <b-button
                variant="outline-danger"
                v-if="clearable && model.length"
                class="no-radius"
                @click.stop="clear()"
              >
                <b-icon icon="x" class="font-size-18"></b-icon>
              </b-button>
              <b-button variant="outline-info" class="help">
                <b-icon icon="calendar-event" class="font-size-16"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback>
              {{ message(validationContext) }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </template>
    </date-picker>
  </ValidationProvider>
</template>
<script>
import DatePicker from "vue2-datepicker";

export default {
  components: {
    DatePicker,
  },
  inheritAttrs: false,
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
    },
    type: {
      type: String,
      default: "text",
    },
    invalid: {
      type: String,
      default: "This field is required",
    },
    value: {},
    max: {
      default: "",
    },
    min: {
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      model: [],
    };
  },
  computed: {
    formattedDate() {
      if (this.model.length == 0) return "";
      let start = this.model[0];
      let end = this.model[1];
      return `${start} ~ ${end}`;
    },
    formattedLabel() {
      if (!this.rules) return this.label;
      if (this.rules.indexOf("required") != -1)
        return this.label + " <span style='color:red'>*</span>";
      return this.label;
    },
  },
  watch: {
    value() {
      this.init();
    },
  },
  methods: {
    onInput(val) {
      this.model = val;
      this.$emit("input", val);
    },
    clear() {
      this.model = [];
      this.$refs.datePicker.closePopup();
      this.$emit("input", []);
    },
    disabledDate(date) {
      const isMax = date > new Date(this.max);
      const isMin = date < new Date(this.min);
      if (this.max != "") return isMax;
      if (this.min != "") return isMin;
      return false;
    },
    message(validationContext) {
      return validationContext.errors[0];
    },
    getValidationState(context) {
      let { dirty, validated, valid = null } = context;
      return dirty || validated ? valid : null;
    },
    init() {
      if (this.value) {
        this.model = this.value;
      } else {
        this.model = [];
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss">
.mx-icon-calendar {
  display: none;
}
.mx-datepicker {
  width: 100% !important;
}
.no-radius {
  border-radius: 0px !important;
  border-right: 0px !important;
}
</style>
